'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _chunk2 = require('lodash/chunk');

var _chunk3 = _interopRequireDefault(_chunk2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _util = require('../../../utils/util');

var _mightyFields = require('../../../lib/mighty-fields');

var _AdditionalLiens = require('./AdditionalLiens');

var _AdditionalLiens2 = _interopRequireDefault(_AdditionalLiens);

var _DefendantInsurers = require('./DefendantInsurers');

var _DefendantInsurers2 = _interopRequireDefault(_DefendantInsurers);

var _FieldSets = require('./FieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseInfo = (_dec = (0, _mobxReact.inject)('CaseStore', 'DefendantStore', 'FunderStore', 'InsurerStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseInfo, _Component);

  function CaseInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseInfo.__proto__ || Object.getPrototypeOf(CaseInfo)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'plaintiffInsuranceInfo', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var plaintiff_insurance_info = this.props._case.plaintiff_insurance_info;

      this.fetchPlaintiffInsurer(plaintiff_insurance_info);
    }
  }, {
    key: 'fetchPlaintiffInsurer',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var insurer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return this.props.InsurerStore.retrieve(data.insurer);

              case 4:
                insurer = _context.sent;

                this.plaintiffInsuranceInfo = _extends({}, data, { insurer: insurer });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchPlaintiffInsurer(_x) {
        return _ref2.apply(this, arguments);
      }

      return fetchPlaintiffInsurer;
    }()
  }, {
    key: 'onDefendantInfoChanged',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _props, _case, DefendantStore;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props = this.props, _case = _props._case, DefendantStore = _props.DefendantStore;
                _context2.next = 3;
                return DefendantStore.upsert(_case, data);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onDefendantInfoChanged(_x2) {
        return _ref3.apply(this, arguments);
      }

      return onDefendantInfoChanged;
    }()
  }, {
    key: 'onSettlementOfferChanged',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(formData) {
        var _props2, CaseStore, _case, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, CaseStore = _props2.CaseStore, _case = _props2._case, data = _extends({}, formData, { case: _case.id });
                _context3.next = 3;
                return CaseStore.upsertCaseSettlementOffer({ data: data });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSettlementOfferChanged(_x3) {
        return _ref4.apply(this, arguments);
      }

      return onSettlementOfferChanged;
    }()
  }, {
    key: 'onPlaintiffInsuranceInfoChange',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(formData) {
        var _props3, CaseStore, _case, insurerData, data, newCaseData;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props3 = this.props, CaseStore = _props3.CaseStore, _case = _props3._case;
                insurerData = formData.insurer;

                if (!(insurerData && !insurerData.id)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return this.props.InsurerStore.create({ caseId: _case.id, insurerData: insurerData, type: 'plaintiff' });

              case 5:
                insurerData = _context4.sent;

              case 6:
                data = {
                  plaintiff_insurance_info: _extends({}, formData, {
                    id: formData.id || _uuid2.default.v4(),
                    insurer: (0, _get3.default)(insurerData, 'id', null)
                  })
                };
                _context4.next = 9;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 9:
                newCaseData = _context4.sent;
                _context4.next = 12;
                return this.fetchPlaintiffInsurer(newCaseData.plaintiff_insurance_info);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPlaintiffInsuranceInfoChange(_x4) {
        return _ref5.apply(this, arguments);
      }

      return onPlaintiffInsuranceInfoChange;
    }()
  }, {
    key: 'onCaseUpdate',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
        var _props4, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _props4 = this.props, _case = _props4._case, CaseStore = _props4.CaseStore;
                _context5.next = 3;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onCaseUpdate(_x5) {
        return _ref6.apply(this, arguments);
      }

      return onCaseUpdate;
    }()
  }, {
    key: 'renderDefendantInsurers',
    value: function renderDefendantInsurers() {
      var _case = this.props._case,
          defendant = _case.defendants[0];

      // Do not render defendant insurers table if there is no defendant on the case
      if (!defendant) {
        return null;
      }

      return _react2.default.createElement(
        _Well2.default,
        { id: 'well-defendant-insurer-info' },
        _react2.default.createElement(_DefendantInsurers2.default, { _case: _case, defendant: defendant })
      );
    }
  }, {
    key: 'renderFieldSets',
    value: function renderFieldSets(wells) {
      var SessionStore = this.props.SessionStore,
          fieldSets = SessionStore.isMightyFreeUser ? (0, _filter3.default)(wells, 'isFree') : wells;


      return fieldSets.map(function (fieldSetProps) {
        return _react2.default.createElement(_mightyFields.EditableCard, _extends({ key: fieldSetProps.title }, fieldSetProps));
      });
    }
  }, {
    key: 'updateCustomFields',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(custom_field_data) {
        var _props5, _case, CaseStore, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _props5 = this.props, _case = _props5._case, CaseStore = _props5.CaseStore, data = { custom_field_data: _extends({}, _case.custom_field_data, custom_field_data) };
                _context6.next = 3;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateCustomFields(_x6) {
        return _ref7.apply(this, arguments);
      }

      return updateCustomFields;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props6 = this.props,
          _case = _props6._case,
          FunderStore = _props6.FunderStore,
          SessionStore = _props6.SessionStore,
          data = _case.custom_field_data || {},
          data_fields = Object.keys(data),
          funder_fields = FunderStore.funder.custom_case_fields,
          fields = (0, _util.joinCustomFields)(funder_fields, data_fields),
          additionalCaseInfoFieldSets = (0, _chunk3.default)(fields.map(function (field) {
        return (0, _util.getCustomFieldset)(FunderStore.funder.custom_case_field_types, field);
      }), 50);


      return _react2.default.createElement(
        'div',
        { className: 'case-info' },
        this.renderFieldSets(this.fieldSetsConfig),
        this.renderDefendantInsurers(),
        this.renderFieldSets(this.caseSettlementFieldSetConfig),
        this.renderFieldSets(this.settlementAmountFieldSetConfig),
        this.renderFieldSets(this.reductionPercentageFieldSetConfig),
        FunderStore.isFinanceCustomer && FunderStore.canSeeCoopReplacementCaseSection && this.renderFieldSets(this.replacementCaseFieldSetConfig),
        !SessionStore.isMightyFreeUser && _react2.default.createElement(_AdditionalLiens2.default, { _case: _case }),
        !!fields.length && additionalCaseInfoFieldSets.map(function (fieldSet, idx) {
          return _react2.default.createElement(_mightyFields.EditableCard, {
            fieldSets: [fieldSet],
            key: 'custom-field-sets-' + idx,
            model: _this2.props._case.custom_field_data,
            onSave: _this2.updateCustomFields,
            title: 'Additional Case Information'
          });
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSetsConfig',
    get: function get() {
      var _props7 = this.props,
          _case = _props7._case,
          SessionStore = _props7.SessionStore,
          defendant = _case.defendants[0];


      return [{
        fieldSets: (0, _FieldSets.fieldSetsPrimaryInfo)(SessionStore.isMightyFreeUser),
        isFree: true,
        model: _case,
        onSave: this.onCaseUpdate,
        title: 'Primary Case Info'
      }, {
        fieldSets: _FieldSets.FIELD_SETS_MEDICAL,
        model: _case,
        onSave: this.onCaseUpdate,
        title: 'Medical Evaluation'
      }, {
        fieldSets: _FieldSets.FIELD_SETS_PLAINTIFF_INSURANCE,
        model: (0, _mobx.toJS)(this.plaintiffInsuranceInfo),
        onSave: this.onPlaintiffInsuranceInfoChange,
        title: 'Plaintiff Insurance Info'
      }, {
        fieldSets: _FieldSets.FIELD_SETS_DEFENDANT,
        model: defendant,
        onSave: this.onDefendantInfoChanged,
        title: 'Defendant\'s Info'
      }];
    }
  }, {
    key: 'caseSettlementFieldSetConfig',
    get: function get() {
      var _case = this.props._case,
          case_settlement_offer = _case.case_settlement_offer;


      return [{
        fieldSets: _FieldSets.FIELD_SETS_SETTLEMENT_OFFER,
        model: case_settlement_offer,
        onSave: this.onSettlementOfferChanged,
        title: 'Settlement Offer'
      }];
    }
  }, {
    key: 'settlementAmountFieldSetConfig',
    get: function get() {
      var _case = this.props._case;


      return [{
        fieldSets: [[{ field: 'settlement_amount', type: 'money' }, { field: 'settlement_date', type: 'date' }]],
        model: _case,
        onSave: this.onCaseUpdate,
        title: 'Settlement Amount'
      }];
    }
  }, {
    key: 'replacementCaseFieldSetConfig',
    get: function get() {
      var _case = this.props._case;


      return [{
        fieldSets: [[{ field: 'is_coop_replacement_case', label: 'Is CoOp Replacement Case?', required: true, type: 'boolean' }, { field: 'replaced_case', label: 'Case ID or Name of Replaced Case', type: 'text' }]],
        model: _case,
        onSave: this.onCaseUpdate,
        title: 'CoOp Replacement Case'
      }];
    }
  }, {
    key: 'reductionPercentageFieldSetConfig',
    get: function get() {
      var _case = this.props._case;


      return [{
        fieldSets: [[{ field: 'reduction_percentage', type: 'twoDecimalPercentage' }]],
        model: _case,
        onSave: this.onCaseUpdate,
        title: 'Reduction Percentage'
      }];
    }
  }]);

  return CaseInfo;
}(_react.Component), _class3.defaultProps = {
  _case: null
}, _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  InsurerStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'plaintiffInsuranceInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'fetchPlaintiffInsurer', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchPlaintiffInsurer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDefendantInfoChanged', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onDefendantInfoChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSettlementOfferChanged', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onSettlementOfferChanged'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseInfo;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseInfo, 'CaseInfo', '/app/src/components/page-case/main-details/CaseInfo.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/CaseInfo.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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